import { Routes } from '@angular/router';
import { AuthGuard } from '@ov-suite/authguard-angular';
import { FeatureKey } from '@ov-suite/helpers-shared/lib/feature.enum';
import { JournalEventsListComponent } from './list/journal-events-list.component';

export const JournalEventsRoutes: Routes = [
  {
    path: '',
    children: [
      {
        data: { feature: { id: FeatureKey.EXCEPTIONS } },
        canActivate: [AuthGuard],
        path: '',
        component: JournalEventsListComponent,
      },
    ],
  },
];
